export default {"src":"/_next/static/image/public/images/ic_share_grey_round.ba08e52ad00e28237a3d815700baf5e6.svg","height":54,"width":54};